module.exports = __webpack_public_path__ + "img/chris1.7c99f0f5.jpg";